import React from "react";
import { ExternalLink } from "components/ExternalLink";
import {
  CodeBlock,
  CopyableCodeLine,
  InlineCode,
} from "onboarding/components/NumberedStep";
import { KB_URL_BASE } from "onboarding/constants";
import { track } from "utils/track";

const PACKAGE_URL = "https://www.npmjs.com/package/appoptics-apm";
const KNOWLEDGEBASE_URL = `${KB_URL_BASE}/apm_tracing/nodejs/install/`;

const nodejsInstructions = props => {
  const { agentRecorderToken, serviceName } = props;
  return [
    {
      precedingContent: (
        <div>
          The Node.js agent is distributed as the npm package{" "}
          <ExternalLink href={PACKAGE_URL}>appoptics-apm</ExternalLink>. See the
          quick instructions below, or{" "}
          <ExternalLink href={KNOWLEDGEBASE_URL}>
            check out our documentation
          </ExternalLink>{" "}
          for more details.
        </div>
      ),
      title: "Install the Node.js agent.",
      content: (
        <div>
          You may need to use npm’s <InlineCode>--unsafe-perm</InlineCode>{" "}
          option when npm install is run as the root user (which may be the
          default in a docker container).
          <div onClick={() => track("Copied the Node.js APM package name")}>
            <CopyableCodeLine language="shell">
              npm install --save appoptics-apm
            </CopyableCodeLine>
          </div>
        </div>
      ),
    },
    {
      title: "The service key is provided via an environment variable.",
      content: (
        <div>
          Make sure this is available in the environment where your application
          is running:
          <div onClick={() => track("Copied the Node.js APM service key")}>
            <CopyableCodeLine language="shell">
              export APPOPTICS_SERVICE_KEY={agentRecorderToken}:{serviceName}
            </CopyableCodeLine>
          </div>
        </div>
      ),
    },
    {
      title: "Load the agent into your application.",
      content: (
        <div>
          Require it in your entry point file before any other{" "}
          <InlineCode>require()</InlineCode> calls. Below is an example with a
          simple express application:
          <div
            onClick={() => track("Copied the Node.js APM require statement")}
          >
            <CodeBlock language="javascript">
              {`
// must be first require
require('appoptics-apm')
const express = require('express')
const app = express()

app.get('/', (req, res) => res.send('Hello World!'))
app.listen(3000, () => console.log('Example app listening on port 3000!'))
              `.trim()}
            </CodeBlock>
          </div>
        </div>
      ),
    },
    {
      title:
        "A few seconds after you restart your application, the agent will be connected to AppOptics.",
    },
  ];
};
export default nodejsInstructions;
